import { orderBy } from 'lodash'
import mapValues from 'lodash/mapValues'
import { splitAdmissionsPeriod } from '../../conduct/generators'
import {
  createAdmissionsSlotsFrom,
  preventAdmissionsOutOfTimelineRange,
  removeHealthProceduresOfAdmissions
} from '../../mappers'
import { IHealthProcedures, ITimelineMaternalInfant } from '~/interfaces'
import {
  byTypeEqualToAdmission,
  byTypeExceptAdmission,
  filterHealthProceduresPer,
  groupByStartDay,
  quantityOfDaysBetweenTwoDates,
  timelineFilters
} from '~/utils'

export interface IPeriodRowValues {
  [date: string]: ITimelineMaternalInfant.IRowSlotsWrapper
}

export const mapperTimelineViewByDaysFrom = (
  healthProcedures: IHealthProcedures[],
  startTrimesterDate: Date,
  endTrimesterDate: Date
): ITimelineMaternalInfant.IDailyTimelineData => {
  const timelineRange = [startTrimesterDate, endTrimesterDate]
  const healthProceduresWithoutAdmissions = filterHealthProceduresPer(healthProcedures, byTypeExceptAdmission)
  const healthProceduresInRange = timelineFilters(healthProceduresWithoutAdmissions).perDate(timelineRange).value

  const admissions = filterHealthProceduresPer(healthProcedures, byTypeEqualToAdmission)
  const admissionSlots = createAdmissionsSlotsFrom(admissions, healthProceduresInRange)
  const admissionsInRange = preventAdmissionsOutOfTimelineRange(admissionSlots, timelineRange)

  const splitAdmissionsSlotsPerDay = splitAdmissionsPeriod(admissionsInRange, 'days')
  const independentHealthProcedures = removeHealthProceduresOfAdmissions(healthProceduresInRange, admissions)
  const orderSlots = orderBy([...splitAdmissionsSlotsPerDay, ...independentHealthProcedures], ['startDate'], ['asc'])

  const groupedByDay = groupByStartDay(orderSlots)

  const groupedDayStructure: IPeriodRowValues = mapValues(
    groupedByDay,
    (groupedHealthProcedure: IHealthProcedures[], key: string) => {
      const dateOfGroupedHealthProcedure = new Date(groupedHealthProcedure[0].startDate)
      const distanceBetweenFirstDate = quantityOfDaysBetweenTwoDates(startTrimesterDate, dateOfGroupedHealthProcedure)

      return {
        id: distanceBetweenFirstDate.toString(),
        date: key,
        rowSlots: groupedHealthProcedure
      }
    }
  )

  return {
    timelineId: new Date(healthProcedures[0].startDate).getTime(),
    days: Object.values(groupedDayStructure).reverse()
  }
}
